<template>
<el-card class="box-card">
    <el-row>
        <el-col :span="24"> <h1>Invoice Flow</h1></el-col>
        <el-col :span="16" class="text-left">
            <el-radio-group v-model="menuSelect" @change="onChangeStatus">
                <el-radio-button :label="item.id" :name="item.label" v-for="item in menuList" :key="item.id" >{{item.label}}<br> <br>({{item.count}} บิล)</el-radio-button>
            </el-radio-group>
        </el-col>
        <el-col :span="8" class="text-right">
                <el-row :gutter="20">
                    <el-col :span="20">
                        <el-date-picker
                            v-model="date"
                            style="width:100%;"
                            type="daterange"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            range-separator="To"
                            start-placeholder="Start date"
                            end-placeholder="End date">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="4">
                        <el-button type="primary" @click="fetchDataStatus">ค้นหา</el-button>
                    </el-col>
                </el-row>
        </el-col>
        <el-col :span="24">
            <tableInvoiceFlow ref="tableDataInvoiceFlow" :status.sync="menuSelect" :date.sync="date" @setCounter="onCounterSet"/>
            <!-- <component :is="currentTabComponent"></component> -->
        </el-col>
    </el-row>
</el-card>
</template>
<script>
import tableInvoiceFlow from '@/components/Invoice/InvoiceFlow/TableInvoiceFlow.vue'
export default {
    name: 'InvoiceFlow',
    components: { tableInvoiceFlow },
    data () {
        return {
            date: '',
            menuList: {
                overdueUnbilled: {
                    id: '1',
                    label: 'ค้างจ่ายเกิน 7 วัน',
                    count: 0
                },
                unbilled: {
                    id: '2',
                    label: 'ค้างจ่ายใน 7 วัน',
                    count: 0
                },
                online: {
                    id: '3',
                    label: 'ตรวจสอบรับชำระ online',
                    count: 0
                },
                pending: {
                    id: '4',
                    label: 'รออนุมัติการชำระเงิน',
                    count: 0
                },
                billed: {
                    id: '5',
                    label: 'ชำระแล้ว',
                    count: 0
                }
            },
            menuSelect: '1',
            billingData: {}
        }
    },
    mounted () {
        this.fetchDataStatus(this.menuSelect)
    },
    computed: {
    },
    methods: {
        fetchDataStatus (statusId, setLimit = false) {
            this.$refs.tableDataInvoiceFlow.fetchData(this.menuSelect, this.date, setLimit)
        },
        onChangeStatus (val) {
            // console.log(val)
            this.fetchDataStatus(val, true)
        },
        onCounterSet (val) {
            this.menuList.overdueUnbilled.count = val.overdueUnbilled
            this.menuList.unbilled.count = val.unbilled
            this.menuList.online.count = val.online
            this.menuList.pending.count = val.pending
            this.menuList.billed.count = val.billed
        }
    }
}
</script>
